import { Dropdown } from "primereact/dropdown";
import React, { useState, useEffect } from "react";

const ReactDropdown = ({ options, optitle, onChange, val, placeholder }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  // Update selectedOption when val prop changes
  useEffect(() => {
    if (val) {
      setSelectedOption(val);
    }
  }, [val]);

  const selectedTemplate = (option) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option[optitle]}</div>
        </div>
      );
    }
    return <span> {placeholder ? placeholder : "Select"} </span>;
  };

  const optionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>{option[optitle]}</div>
      </div>
    );
  };

  const handleChange = (e) => {
    setSelectedOption(e.value);
    if (onChange) {
      onChange(e); // call the onChange prop to update parent component state
    }
  };

  const renderVal = val || selectedOption;
  
  // Ensure options is always an array to prevent findIndex errors
  const safeOptions = Array.isArray(options) ? options : [];

  return (
    <div className="flex justify-content-center">
      <Dropdown
        value={renderVal}
        onChange={handleChange}
        options={safeOptions}
        optionLabel={optitle}
        placeholder={placeholder || "Select"}
        filter
        valueTemplate={selectedTemplate}
        itemTemplate={optionTemplate}
        className="md:w-12rem drop"
        showClear
      />
    </div>
  );
};

export default ReactDropdown;